/**
 * Remoting XPAC API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TelemetryEventType = 'dependency' | 'exception' | 'request' | 'trace';

export const TelemetryEventType = {
    Dependency: 'dependency' as TelemetryEventType,
    Exception: 'exception' as TelemetryEventType,
    Request: 'request' as TelemetryEventType,
    Trace: 'trace' as TelemetryEventType
};

